// Employee Details
export const Employee = "Employee";
export const EmployeeId = "EmployeeId";
export const EmployerAndDivision = "EmployeeAndDivision";
export const DateOfBirth = "DateOfBirth";
export const PersonalReferenceNumber = "PersonalReferenceNumber";
export const EmployeeUniqueID = "EmployeeUniqueID";
export const JobRole = "JobRole";
export const HrManager = "HrManager";
export const Worksite = "Worksite";
export const DateMethod = "DateMethod";

// Referral Details
export const ReasonForReferral = "ReasonForReferral";
export const Diagnosis = "Diagnosis";
export const NumberOfSessions = "NumberOfSessions";
export const IntroductionAndDataPrivacyConsultationMethod = "IntroductionAndDataPrivacyConsultationMethod";

// Treatment Received
export const TreatmentReceivedAnswers = "TreatmentReceivedAnswers";

// Outcome
export const OutcomeAnswers = "OutcomeAnswers";

// Work Status
export const WorkStatusAtInitialAssessment = "WorkStatusAtInitialAssessment";
export const WorkStatusAtDischarge = "WorkStatusAtDischarge";

// Questionnaire Scores
export const QuestionnaireScoresAtInitialAssessmentPHQ9 = "QuestionnaireScoresAtInitialAssessmentPHQ9";
export const QuestionnaireScoresAtInitialAssessmentGAD7 = "QuestionnaireScoresAtInitialAssessmentGAD7";
export const QuestionnaireScoresAtInitialAssessmentWSAS = "QuestionnaireScoresAtInitialAssessmentWSAS";
export const QuestionnaireScoresAtDischargePHQ9 = "QuestionnaireScoresAtDischargePHQ9";
export const QuestionnaireScoresAtDischargeGAD7 = "QuestionnaireScoresAtDischargeGAD7";
export const QuestionnaireScoresAtDischargeWSAS = "QuestionnaireScoresAtDischargeWSAS";

// Further Adjustments/Recommendations
export const FurtherAdjustmentsRecommendationsComments = "FurtherAdjustmentsRecommendationsComments";
